import countryCodeBindings from './bindings/countryCode';
/* eslint-disable  no-useless-escape */
/* eslint-disable  import/prefer-default-export */
export const validateEmail = email =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    String(email).toLowerCase()
  );

export const shouldMakeCustomDeclaration = (countryCode, postalCode) => {
  const country = countryCodeBindings.find(
    countryCodeBinding => countryCodeBinding.value === countryCode
  );
  const isInEuropeanUnion = country ? country.inEuropeanUnion : true;

  const isMilitaryHub = postalCode === '00100' || postalCode === '00200';

  if (isInEuropeanUnion || isMilitaryHub) {
    return false;
  }
  return true;
};
